export const formatter = (value: number | string | undefined) =>
  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ");

export const parser = (value: string | undefined) => {
  if (!value || value.trim() === "") {
    return "0";
  } else {
    return value.replace(/\$\s?|( *)/g, "").replace(",", ".");
  }
};
